import * as React from 'react';

export function GridIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={20} height={20} viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 2V7H6.997L7 2H2ZM7 9H2C0.897 9 0 8.103 0 7V2C0 0.898 0.897 0 2 0H7C8.103 0 9 0.898 9 2V7C9 8.103 8.103 9 7 9V9Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M13 2V7H17.997L18 2H13ZM18 9H13C11.897 9 11 8.103 11 7V2C11 0.898 11.897 0 13 0H18C19.103 0 20 0.898 20 2V7C20 8.103 19.103 9 18 9V9Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 13V18H6.997L7 13H2ZM7 20H2C0.897 20 0 19.103 0 18V13C0 11.898 0.897 11 2 11H7C8.103 11 9 11.898 9 13V18C9 19.103 8.103 20 7 20V20Z'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M13 13V18H17.997L18 13H13ZM18 20H13C11.897 20 11 19.103 11 18V13C11 11.898 11.897 11 13 11H18C19.103 11 20 11.898 20 13V18C20 19.103 19.103 20 18 20V20Z'
			/>
		</svg>
	);
}
